import checkIcon from "assets/images/requirements-check.svg";
import xIcon from "assets/images/requirements-x.svg";
import classNames from "classnames";
import React from "react";
import {passwordRequirements as strings} from "strings";

import {hasDistinctCharacters} from "liberty-core/sharedFunctions";

import styles from "./PasswordRequirements.module.css";

const MINIMUM_LENGTH = 10;
const MINIMUM_DISTINCT_CHARS = 5;

type Props = {
  password: string;
};

export default function PasswordRequirements(props: Props) {
  function renderRequirement(label: string, requirementMet: boolean) {
    return (
      <div className={styles.requirement}>
        <img
          className={styles.reqIcon}
          src={requirementMet ? checkIcon : xIcon}
          alt={requirementMet ? strings.fulfilled : strings.unfulfilled}
        />
        <div
          className={classNames(
            styles.label,
            requirementMet && styles.labelGreen,
          )}
        >
          {label}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        {renderRequirement(
          strings.distinct(MINIMUM_DISTINCT_CHARS),
          hasDistinctCharacters(MINIMUM_DISTINCT_CHARS, props.password),
        )}
        {renderRequirement(
          strings.minimum(MINIMUM_LENGTH),
          props.password.length >= MINIMUM_LENGTH,
        )}
      </div>
      <div className={styles.row}>
        {renderRequirement(
          strings.uppercase,
          !!props.password.match(/[A-Z]/g)?.length,
        )}
        {renderRequirement(
          strings.lowercase,
          !!props.password.match(/[a-z]/g)?.length,
        )}
      </div>
      <div className={styles.row}>
        {renderRequirement(
          strings.number,
          !!props.password.match(/[0-9]/g)?.length,
        )}
      </div>
    </div>
  );
}
